exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".home.container-fluid{overflow:hidden}.home .content-section{max-width:1220px}.home .marketing .circle-section{overflow:visible}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Home/Home.scss
// module id = 7514
// module chunks = 13